import React from 'react';
import { FormattedMessage } from 'react-intl';
import style from './printButton.module.scss';
import { isApplicationRunningOniOS } from 'acscp/components/common/helpers/isApplicationRunningOniOS';
import { Printer } from '@awesome-cordova-plugins/printer';

export const PrintButton: React.SFC<{}> = props => {
    const clickHandler = () => {
        if (window.cordova && cordova.plugins && cordova.plugins.printer) { // detect presence of the mobile plugin
            void Printer.print();
        } else {
            window.print();
        }
    };

    // Printer formatting is currently broken on iOS, so it is disabled
    const showPrintButton = !isApplicationRunningOniOS();

    return showPrintButton ? (
        <button
            className={style.Button}
            onClick={clickHandler}
        >
            <FormattedMessage id={'components.itinerary.printButton'} defaultMessage={'Print'}/>
        </button>
    ) : null;
};
